import { render, staticRenderFns } from "./orderConfirmState.vue?vue&type=template&id=7b2720c1&scoped=true"
import script from "./orderConfirmState.vue?vue&type=script&lang=js"
export * from "./orderConfirmState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2720c1",
  null
  
)

export default component.exports